// extracted by mini-css-extract-plugin
module.exports = {"SectionA1":"SliceCard_SectionA1__3ROzF","CircleProgress":"SliceCard_CircleProgress___8PIW"};